import { render, staticRenderFns } from "./sxzjlist.vue?vue&type=template&id=521b2edb&scoped=true&"
import script from "./sxzjlist.vue?vue&type=script&lang=js&"
export * from "./sxzjlist.vue?vue&type=script&lang=js&"
import style0 from "./sxzjlist.vue?vue&type=style&index=0&id=521b2edb&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b2edb",
  null
  
)

export default component.exports